//Core lib
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LazyElementsModule } from '@angular-extensions/elements';
import { NgSelectModule } from '@ng-select/ng-select';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { NgxPaginationModule } from 'ngx-pagination';
import { MdbDraggableModule } from 'mdb-draggable';
import { GravatarModule } from 'ngx-gravatar';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { CKEditorModule } from 'ngx-ckeditor';


import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';


import { TruncatePipe } from './pipe/truncate.pipe';
import { NavTimeDirective } from '../shared/directives/itemNav.directive';
import { NoResultComponent } from '../shared/components/noresult';

import { MomentModule } from 'ngx-moment';

import { UploadComponent } from '../header/header-component/upload/upload.component';
import { SpinneerComponent } from '../utils/loader';
import { CommonDeleteModalComponent } from '../common/modals/common-delete-modal/common-delete';

import { Debounce } from './directives/debounce.directive';
import { DragDropDirective } from './directives/drag-drop.directive';
import {IconPickerComponent} from '../common/modals/icon-picker/icon-picker.component'

import {EmailRecipientsTabComponent} from '../common/components/email-recipients/email-recipients.component';
import {NotificationModalComponent} from '../common/components/notification-modal/notification-modal.component';
import { EditComponentTab } from '../common/components/edit-components/edit-component';
import { MarkRecievedModalComponent } from '../common/components/mark-recieved-modal/mark-recieved-modal.component';
import { MarkSelectionsSentModalComponent } from '../common/components/mark-selections-sent/mark-selections-sent.component';
import { MarkSelectionsCancelModalComponent } from '../common/components/mark-selections-cancel/mark-selections-cancel.component';
import { DownloadSelectionsModalComponent } from '../common/components/download-selections-modal/download-selections-modal.component';
import { EmailSelectionNoticesModalComponent } from '../common/components/email-selection-notices/email-selection-notices.component';
import {GenerateSelectionLetttersModalComponent} from '../common/components/generate-selection-letters/generate-selection-letters.component'
import {DeleteSelectionsModalComponent} from '../common/components/delete-selections-modal/delete-selections-modal.component';
import {EditDocumentTagsComponent} from '../common/components/edit-document-tags-modal/edit-document-tags-modal.component'
import {MarkTestedModalComponent} from '../common/components/mark-tested/mark-tested.component';
import {MarkCanceledModalComponent} from '../common/components/mark-cancelled/mark-cancelled.component';
import { CommonDocumentWarningComponent } from '../common/modals/common-document-warning-modal/common-document-warning-modal.component';
import { AddDocumentModalComponent} from '../common/modals/add-document-modal/add-document-modal.component'

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const customCurrencyMaskConfig = {
    align: "right",
    allowNegative: true,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "R$ ",
    suffix: "",
    thousands: ".",
    nullable: true
};

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxPaginationModule,
        FilterPipeModule,
        NgSelectModule,       
        MDBBootstrapModulesPro.forRoot(),
        MdbDraggableModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        GravatarModule,
        CKEditorModule,
        LazyElementsModule

    ],
    declarations: [
        DragDropDirective,
        Debounce,
        NoResultComponent,
        SpinneerComponent,
        NavTimeDirective,
        TruncatePipe,
        //header components
        UploadComponent,
        //common modals
        CommonDeleteModalComponent,
        IconPickerComponent,
        EmailRecipientsTabComponent,
        NotificationModalComponent,
        EditComponentTab,
        MarkRecievedModalComponent,
        MarkSelectionsSentModalComponent,
        MarkSelectionsCancelModalComponent,
        DownloadSelectionsModalComponent,
        EmailSelectionNoticesModalComponent,
        GenerateSelectionLetttersModalComponent,
        DeleteSelectionsModalComponent,
        EditDocumentTagsComponent,
        MarkTestedModalComponent,
        MarkCanceledModalComponent,
        CommonDocumentWarningComponent,
        AddDocumentModalComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        TranslateModule,
        MDBBootstrapModulesPro,
        MdbDraggableModule,
        NgSelectModule,
        NgxPaginationModule,
        LazyElementsModule,
        CKEditorModule,
        FilterPipeModule,
        NoResultComponent,
        SpinneerComponent,
        NavTimeDirective,
        TruncatePipe,



        //header components
        UploadComponent,
        //common modals
        CommonDeleteModalComponent,
        GravatarModule,

        DragDropDirective,
        MomentModule,
        IconPickerComponent,
        EmailRecipientsTabComponent,
        NotificationModalComponent,
        EditComponentTab,
        MarkRecievedModalComponent,
        MarkSelectionsSentModalComponent,
        MarkSelectionsCancelModalComponent,
        DownloadSelectionsModalComponent,
        EmailSelectionNoticesModalComponent,
        GenerateSelectionLetttersModalComponent,
        DeleteSelectionsModalComponent,
        EditDocumentTagsComponent,
        MarkTestedModalComponent,
        MarkCanceledModalComponent,
        CommonDocumentWarningComponent,
        AddDocumentModalComponent
    ]
})
export class SharedModule {
    constructor(private translate: TranslateService) {
        const userSettingsJson = localStorage.getItem("userSettingsJson");
        const lang = userSettingsJson ? JSON.parse(userSettingsJson).preferredLanguageCode : 'en';

        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang("en");
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(lang).subscribe(res=>{},
            err=>{
                this.translate.use("en")
                const userSettings = { preferredLanguageCode: 'en'};
                localStorage.setItem("userSettingsJson", JSON.stringify(userSettings));
            });

    }
}

